import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import InformationalPopup from '../../../../../../../common-components/InformationalPopup'
import RevealContactInfo from '../../../../../../../common-components/RevealContactInfo'
import TextAsPseudoLink from '../../../../../../../common-components/TextAsPseudoLink'

const POPUP_MOBILE_MEDIA_QUERY = '(max-width: 767px)'

function getDoesViewportMatchMobilePopup() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false
  }
  return window.matchMedia(POPUP_MOBILE_MEDIA_QUERY).matches
}

export default ({
  handleReturnToPreviousScreen,
}) => {
  const { t: translate } = useTranslation('common')
  const [isMobileViewport, setIsMobileViewport] = useState(getDoesViewportMatchMobilePopup)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined
    }

    const mediaQuery = window.matchMedia(POPUP_MOBILE_MEDIA_QUERY)
    const onViewportChange = event => {
      setIsMobileViewport(event.matches)
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', onViewportChange)
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(onViewportChange)
    }

    setIsMobileViewport(mediaQuery.matches)

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', onViewportChange)
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(onViewportChange)
      }
    }
  }, [])

  return (
    <InformationalPopup
      includeTriggerIcon={false}
      includeTriggerText
      triggerText={translate('neverReceivedConfirmationCode')}
      popupProps={{
        on: 'click',
        position: isMobileViewport ? 'bottom center' : 'right center',
      }}
      content={(
        <div style={{ width: '300px' }}>
          <p>
            <TextAsPseudoLink
              onClick={handleReturnToPreviousScreen}
            >
              {translate('clickHere')}
            </TextAsPseudoLink>
            {' '}
            {translate('resetPasswordReturnToPreviousPage')}
          </p>
          <RevealContactInfo />
        </div>
      )}
    />
  )
}